import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { peterboroughConfig } from "./data";

export default function PeterboroughPage() {
  return <CityPageTemplate config={peterboroughConfig} />;
}